import { words } from './words.js';

// Select a random word from the dictionary
export const selectRandomWord = (selectedCategory = null) => {
  let filteredWords = words;

  // Filter by category if specified
  if (selectedCategory && selectedCategory !== 'all') {
    filteredWords = words.filter(
      wordObj => wordObj.category === selectedCategory
    );
  }

  if (filteredWords.length === 0) {
    // Fallback to all words if category is empty
    filteredWords = words;
  }

  const randomIndex = Math.floor(Math.random() * filteredWords.length);
  return filteredWords[randomIndex].word.toUpperCase();
};

// Initialize game state
export const initializeGame = (selectedCategory = null) => {
  const word = selectRandomWord(selectedCategory);
  return {
    word: word,
    guessedLetters: new Set(),
    wrongGuesses: 0,
    gameStatus: 'playing', // 'playing', 'won', 'lost'
  };
};

// Check if a letter is in the word
export const isLetterInWord = (letter, word) => {
  return word.includes(letter.toUpperCase());
};

// Get the display word with blanks and guessed letters
export const getDisplayWord = (word, guessedLetters) => {
  return word
    .split('')
    .map(letter => (guessedLetters.has(letter) ? letter : '_'))
    .join(' ');
};

// Check if the word has been completely guessed
export const isWordComplete = (word, guessedLetters) => {
  return word.split('').every(letter => guessedLetters.has(letter));
};

// Check if the game is won
export const checkWin = (word, guessedLetters) => {
  return isWordComplete(word, guessedLetters);
};

// Check if the game is lost
export const checkLose = (wrongGuesses, maxGuesses) => {
  return wrongGuesses >= maxGuesses;
};

// Process a letter guess
export const processGuess = (letter, gameState) => {
  const upperLetter = letter.toUpperCase();
  const newGuessedLetters = new Set(gameState.guessedLetters);

  // Don't process if already guessed
  if (newGuessedLetters.has(upperLetter)) {
    return gameState;
  }

  newGuessedLetters.add(upperLetter);

  const isCorrect = isLetterInWord(upperLetter, gameState.word);
  const newWrongGuesses = isCorrect
    ? gameState.wrongGuesses
    : gameState.wrongGuesses + 1;

  const newGameState = {
    ...gameState,
    guessedLetters: newGuessedLetters,
    wrongGuesses: newWrongGuesses,
  };

  // Check win/lose conditions
  if (checkWin(gameState.word, newGuessedLetters)) {
    newGameState.gameStatus = 'won';
  } else if (checkLose(newWrongGuesses, 6)) {
    newGameState.gameStatus = 'lost';
  }

  return newGameState;
};
